import { t } from 'i18next';

export const AdditionalRequestStatusEnum = Object.freeze({
    OPEN: 'OPEN',
    VALIDATION_REQUESTED: 'VALIDATION_REQUESTED',
    VALIDATION_CONFIRMED: 'VALIDATION_CONFIRMED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
});

export function getAdditionalRequestsStatusesOptions() {
    const options = {
        [AdditionalRequestStatusEnum.OPEN]: { key: AdditionalRequestStatusEnum.OPEN, label: t('Nouveau') },
        [AdditionalRequestStatusEnum.VALIDATION_REQUESTED]: {
            key: AdditionalRequestStatusEnum.VALIDATION_REQUESTED,
            label: t('Pending validation'),
        },
        [AdditionalRequestStatusEnum.VALIDATION_CONFIRMED]: {
            key: AdditionalRequestStatusEnum.VALIDATION_CONFIRMED,
            label: t('Processing in progress'),
        },
        [AdditionalRequestStatusEnum.COMPLETED]: { key: AdditionalRequestStatusEnum.COMPLETED, label: t('Finished') },
        [AdditionalRequestStatusEnum.CANCELLED]: { key: AdditionalRequestStatusEnum.CANCELLED, label: t('Canceled') },
    };
    return options;
}
export function getAdditionalRequestsStatusLabel(key) {
    const options = getAdditionalRequestsStatusesOptions();
    return options?.[key]?.label || '';
}

export function getAdditionalRequestsTypes() {
    const options = {
        QUALITY_CONTROL: {
            key: 'QUALITY_CONTROL',
            label: t('Quality control'),
            subTypes: {
                VISUAL_INSPECTION: { key: 'VISUAL_INSPECTION', label: t('Visual inspection') },
                QUANTITATIVE_CHECK: { key: 'QUANTITATIVE_CHECK', label: t('Quantitative check') },
                COMPLIANCE_CHECK: { key: 'COMPLIANCE_CHECK', label: t('Compliance check') },
                SPECIFIC_CHECK: { key: 'SPECIFIC_CHECK', label: t('Specific check') },
            },
        },
        TARGETED_INVENTORY: {
            key: 'TARGETED_INVENTORY',
            label: t('Targeted inventory'),
            subTypes: {
                INVENTORY_BY_LOCATION: { key: 'BY_LOCATION', label: t('Invertory by location') },
                INVENTORY_BY_REFERENCE_SKU: { key: 'BY_REFERENCE_SKU', label: t('Invertory by reference or sku') },
                INVENTORY_BY_BATCH_EXPIRY: { key: 'BY_BATCH_EXPIRY', label: t('Invertory by batch expiry') },
                INVENTORY_BY_SSCC: { key: 'BY_SSCC', label: t('Invertory by sscc') },
                INVENTORY_FOLLOWING_A_DISPUTE: {
                    key: 'INVENTORY_FOLLOWING_A_DISPUTE',
                    label: t('Inventory following a dispute'),
                },
            },
        },
        RE_LABELING: {
            key: 'RE_LABELING',
            label: t('Re labeling'),
            subTypes: {
                REPLACEMENT_OF_LABELS: { key: 'REPLACEMENT_OF_LABELS', label: t('Replacement of labels') },
                ADDING_OF_MISSING_LABELS: { key: 'ADDING_OF_MISSING_LABELS', label: t('Adding of missing labels') },
                LABELLING_CORRECTION: {
                    key: 'LABELLING_CORRECTION',
                    label: t('Labelling correction (barcodes, labels)'),
                },
                ADDING_REGULATORY_LABELS: {
                    key: 'ADDING_REGULATORY_LABELS',
                    label: t('Adding regulatory/country labels'),
                },
            },
        },
        REPACKAGING: {
            key: 'REPACKAGING',
            label: t('Repackaging'),
            subTypes: {
                SORTING_SEPARATE: { key: 'SORTING_SEPARATE', label: t('Sorting/separation') },
                DECONSTITUTION_RECOMPOSITION: {
                    key: 'DECONSTITUTION_RECOMPOSITION',
                    label: t('Deconstitution/recomposition'),
                },
                NEW_FORMAT: { key: 'NEW_FORMAT', label: t('Repackaging in a new format') },
                ADDING_REMOVE_ITEMS: { key: 'ADDING_REMOVE_ITEMS', label: t('Adding/removing items') },
            },
        },
        RE_PALLETIZING: {
            key: 'RE_PALLETIZING',
            label: t('Re palletizing'),
            subTypes: {
                EURO_PALLET: { key: 'EURO_PALLET', label: t('Re-palletising European pallets') },
                LOST_PALLET: { key: 'LOST_PALLET', label: t('Re-palletising of lost pallets') },
                HALF_PALLET_ROLL: { key: 'HALF_PALLET_ROLL', label: t('Half pallet passage / roll ') },
                CONSOLIDATE_DECONSOLIDATE: {
                    key: 'CONSOLIDATE_DECONSOLIDATE',
                    label: t('Consolidate or deconsolidate'),
                },
            },
        },
        PHOTO_CAPTURE: {
            key: 'PHOTO_CAPTURE',
            label: t('Photo capture'),
            subTypes: {
                PRODUCT_PHOTOS: { key: 'PRODUCT_PHOTOS', label: t('Product photos') },
                PALLET_SUPPORT_PHOTOS: { key: 'PALLET_SUPPORT_PHOTOS', label: t('Pallet support photos') },
                DISPUTE_DAMAGE_PHOTOS: { key: 'DISPUTE_DAMAGE_PHOTOS', label: t('Dispute damage photos') },
                PHOTO_REPORT: { key: 'PHOTO_REPORT', label: t('Photo report') },
            },
        },
        OTHER: {
            key: 'OTHER',
            label: t('Other'),
            subTypes: {},
        },
    };
    return options;
}
export function getAdditionalRequestsTypeLabel(key) {
    const options = getAdditionalRequestsTypes();
    return options?.[key]?.label || '';
}

export function getAdditionalRequestsSubTypes(key) {
    const options = getAdditionalRequestsTypes();
    return options?.[key]?.subTypes || {};
}

export function getAdditionalRequestsSubTypeLabel(key, subKey) {
    const options = getAdditionalRequestsTypes();
    return options?.[key]?.subTypes?.[subKey]?.label || '';
}

export function getAdditionalRequestsServiceTypesOptions() {
    const labels = {
        INCLUDED: { value: 'INCLUDED', label: t('Included in the contract') },
        BILLABLE: { value: 'BILLABLE', label: t('Billable') },
    };
    return labels;
}

export function getAdditionalRequestsServiceTypeLabel(key) {
    const options = getAdditionalRequestsServiceTypesOptions();
    return options?.[key]?.label || '';
}

export const additionalRequestPriorityOutputValues = {
    URGENT: '40_URGENT',
    HIGH: '30_HIGH',
    MEDIUM: '20_MEDIUM',
    LOW: '10_LOW',
};

export const additionalRequestPriorityInputValues = {
    '40_URGENT': 'URGENT',
    '30_HIGH': 'HIGH',
    '20_MEDIUM': 'MEDIUM',
    '10_LOW': 'LOW',
};

export function normalizeAdditionalRequest(response) {
    return {
        ...response,
        type: response.additionalData?.additionalRequest?.type,
        subType: response.additionalData?.additionalRequest?.subType,
        serviceFees: response.additionalData?.additionalRequest?.serviceFees,
        serviceType: response.additionalData?.additionalRequest?.serviceType,
        priority: additionalRequestPriorityInputValues[response.priority],
    };
}
